import dalton from '../client';

export const DO_UNSET_COOKIE_ENDPOINT = '/sso/api/1/unset';
export const DO_UNSET_COOKIE_METHOD = 'POST';

/**
 * Unset the federated cookie
 *
 * This does not log user out, but does prevent automatic authorization on a new core.
 */
export default async function doUnsetCookie() {
    const resp = await dalton.request<string>({
        data: {},
        method: DO_UNSET_COOKIE_METHOD,
        url: DO_UNSET_COOKIE_ENDPOINT,
        withCredentials: true, // FISFG cookie
    });

    return resp.data;
}
